import { render, staticRenderFns } from "./CustomText.vue?vue&type=template&id=37c73e6b"
import script from "./CustomText.vue?vue&type=script&lang=ts"
export * from "./CustomText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports